import styled, { css } from 'styled-components'

type ContainerProps = {
  fullHeight?: boolean
  fullWidth?: boolean
}

const Container = styled.div<ContainerProps>`
  position: relative;
  width: 80%;
  margin-left: auto;
  margin-right: auto;
  transition: 0.2s;

  ${({ fullWidth }) =>
    fullWidth &&
    css`
      max-width: initial;
    `}

  ${({ fullHeight }) =>
    fullHeight &&
    css`
      height: 100%;
    `};
`

export default Container
